import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Warehouse } from 'src/app/models/Warehouse';
import { CountryService } from 'src/app/shared/country.service';

import { UpdateWarehouse } from '../warehouse.actions';

@Component({
    selector: 'app-warehouse-update-modal',
    templateUrl: './warehouse-update-modal.component.html',
    styleUrls: ['./warehouse-update-modal.component.scss'],
})
export class WarehouseUpdateModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();
    @Input() warehouse: Warehouse;
    allCountries = [];

    warehouseFormGroup: FormGroup;
    loading = false;
    inputIsWrong = false;
    newWarehouse: Warehouse;

    saveWarehouseWentWrong = false;
    errorMessage: string;
    DESCRIPTION_MAX_LENGTH = 1000;
    currentAmountOfDescriptionCharacters: number;
    descriptionIsTooLong = false;

    constructor(
        private formBuilder: FormBuilder,
        public activeModal: NgbActiveModal,
        private countryService: CountryService,
        private store: Store,
        private toastr: ToastrService,
        private logger: NGXLogger,
    ) {}

    ngOnInit(): void {
        this.allCountries = this.countryService.getAllCountries();
        this.warehouseFormGroup = this.formBuilder.group({
            title: [this.warehouse.title, [Validators.required]],
            shortName: [this.warehouse.shortName],
            description: [this.warehouse.description],
            address: this.formBuilder.group({
                street: [this.warehouse.address.street, [Validators.required]],
                number: [this.warehouse.address.number, [Validators.required]],
                bus: [this.warehouse.address.bus],
                ext: [this.warehouse.address.ext],
                postal: [this.warehouse.address.postal, [Validators.required]],
                city: [this.warehouse.address.city, [Validators.required]],
                country: this.formBuilder.group({
                    iso2: [this.warehouse.address.country.iso2, [Validators.required]],
                }),
            }),
        });
    }

    updateWarehouse() {
        this.loading = true;

        if (!this.warehouseFormGroup.valid) {
            this.inputIsWrong = true;
            this.loading = false;
            return;
        }

        this.newWarehouse = this.warehouseFormGroup.value;
        this.newWarehouse.uuid = this.warehouse.uuid;
        this.warehouseFormGroup.disable();

        this.logger.debug('Attempt to update warehouse');
        this.subscriptions.add(
            this.store.dispatch(new UpdateWarehouse(this.newWarehouse)).subscribe(
                () => {
                    this.logger.debug('Succesfully updated warehouse');
                    this.activeModal.close();
                    this.toastr.success('Warehouse updated succesfully');
                },
                (errorMessage) => {
                    this.logger.error('Failed to update warehouse');
                    this.errorMessage = errorMessage.error.message ?? 'Error message was empty';
                    this.saveWarehouseWentWrong = true;
                    this.loading = false;
                    this.warehouseFormGroup.enable();
                },
            ),
        );
    }

    // Hides the error messages that appear after a user has submitted invalid data
    hideErrorMessage() {
        this.inputIsWrong = false;
    }

    onDescriptionKeyUp() {
        this.descriptionIsTooLong = false;
        this.currentAmountOfDescriptionCharacters = this.warehouseFormGroup.controls.description.value.length;
        if (this.currentAmountOfDescriptionCharacters > this.DESCRIPTION_MAX_LENGTH) {
            this.descriptionIsTooLong = true;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
